import { Directive, AfterViewInit, OnChanges } from "@angular/core";
import {
	Input,
	Output,
	EventEmitter,
	ElementRef,
	HostListener,
} from "@angular/core";
import { Subscription } from "rxjs";
import { AppServices } from "app/app.services";
import { ApplicationModel } from "app/core/models/application.model";

@Directive({
	selector: "[appVideo]",
})
export class VideoDirective implements OnChanges {
	@Input() video_url: string;
	@Input() video_width?: string;
	@Input() video_height?: string;
	@Input() autoplay?: boolean;
	@Input() controls?: boolean;
	@Input() loop?: boolean;
	@Input() pauseVideo: boolean;

	@Output() startHandler?: EventEmitter<any> = new EventEmitter<any>();
	@Output() completehandler?: EventEmitter<any> = new EventEmitter<any>();
	@Output() pausehandler?: EventEmitter<any> = new EventEmitter<any>();

	private video_el: HTMLVideoElement;
	private videoPauseSubscription: Subscription;

	constructor(
		private elementRef: ElementRef,
		private appServices: AppServices
	) {
		this.video_el = elementRef.nativeElement;
		this.videoPauseSubscription = appServices.videoPauseEvent$.subscribe(
			(event) => this.videoPauseHandler()
		);
	}
	ngOnChanges(changes) {
		if (
			changes.hasOwnProperty(`pauseVideo`) &&
			changes[`pauseVideo`][`currentValue`] !== undefined
		) {
			if (changes[`pauseVideo`][`currentValue`] === true) {
				if (ApplicationModel.instance.videoOverlay) {
					this.video_el.pause();
				}
			} else {
				this.video_el.play().then(() => {console.log('playing audio')}).catch((e) => {console.log('error in playing audio', e)});
			}
		} else if (changes.hasOwnProperty(`video_url`)) {
			this.video_el.pause();
			this.video_el.src = changes.video_url.currentValue;
			if (!ApplicationModel.instance.videoOverlay) {
				this.video_el.play().then(() => {console.log('playing audio')}).catch((e) => {console.log('error in playing audio', e)});
			}
		}
	}
	ngAfterViewInit() {
		if (!this.video_el) return;
		//this.video_el.src = this.video_url;
		this.video_el.style.width = this.video_width
			? this.video_width + "px"
			: "100%";
		this.video_el.style.height = this.video_height ? this.video_height : "100%";
		this.video_el.autoplay = this.autoplay ? true : false;
		this.video_el.controls = this.controls ? true : false;
		this.video_el.loop = this.loop ? true : false;
		let _owner = this;
		this.video_el.addEventListener("ended", function () {
			_owner.completehandler.emit({
				url: _owner.video_el.currentSrc,
				status: "complete",
			});
		});
		this.video_el.addEventListener("play", function () {
			_owner.startHandler.emit({
				url: _owner.video_el.currentSrc,
				status: "start",
			});
		});
		this.video_el.addEventListener("pause", function () {
			_owner.pausehandler.emit({
				url: _owner.video_el.currentSrc,
				status: "pause",
			});
		});
	}

	private videoPauseHandler() {
		this.video_el.pause();
	}
}
